var _defs, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 966 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_467",
    x1: 11,
    y1: 10.5,
    x2: 951,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0347ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b300a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca00"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar"
  }, /*#__PURE__*/React.createElement("image", {
    width: 966,
    height: 25,
    opacity: 0.64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8YAAAAZCAYAAADzETemAAAACXBIWXMAAAsSAAALEgHS3X78AAADgUlEQVR4Xu3d3W7bRhAG0I/+d5s0SPr+79i6SVxHjtgL7ogrmpKNAJWC9hxgQYqiresPMzs7jOMYAAAA+L+6eu2FQ4ZhGF57BwAAAE5l/MHK7/CWv1uE4EP3AAAAcC59uN3dvyUsHw3GLRBX+L2ox90CAACAn8XYrSTZ1vNjAflgK3UXii9WVj1PBGQAAADOa+yu27U1DMPB6vFqxbiF4grBl21ddesyc0DWWg0AAMCpLVunKxR/b+u5W9/bd9u1cPyiYryoFF8luU5y09Ztu15nDsyCMQAAAKe2DMYViDdJvrX11K6bTAE5wzC8CMdrrdQVii8zBeDbJL906749u25/b88xAAAA59DvKa5Q/HdbX7tVNmn14D4c7wXjbvp0H4zvk7xP8ltb7zIF5ArHay3VAAAA8G/rW6irUvw1yeckD5ly7fK9fjhXkuMV46vM1eL3ST4m+ZTkQ/t8n6mtutqpBWMAAABOqa8Wf8tUKf6c5M/MeXe53/hFdj0UjIfMFeO7JL9mCsSfkvze7qtq3LdTAwAAwKlUMH7OXC1+yJRTt5nDcq2+43m9lbqz3Gd8lykIv8vUTv2h3d+1/+HoJgAAAE6pP6v4OdOgrZtMuXSTKSRXp3OdrrRa1F0G42Gx+iObakJ1P6W6fqBSNwAAAJxK7RuuvcSbzIOil0cNp7tmGIahBnAtg/G4WHUYcvVkb7I/+vqifa9iDAAAwCmtVYz7o5n684vr3V379MGp1J3+YOQad12TvW4zl6btMQYAAOBcDu0x/ivJlySP7XmF5BcTqZP1YLx2BtSXTFO9Ltvzx5hKDQAAwHkdm0r9R7uvcNxXj189rqmqxVWK/pq5Klyh+CHOMQYAAOC8+m3Aa+cYP7TPT5kybt9WvbMXjMdxHIdhGLLfRv2YORQ/ZW6nrg3N/bAuAAAAOJV+Rlbf9VzbgWtVMK526j3HKsb1T+tZ/cBNplB8mbmNugjHAAAAnEIfcCsYV46tgdHLgVxjpprwXjgeFp+nh1PVuD+qqY5rWht5LRgDAABwastg3Bd562Sl5XTq7TIUJweCcbILx31A7lc9T4RhAAAAzmvsrtsD60WluBwMxsleOE72g7A9xQAAAPxs+j3HyRSIkyOhOHklGO9emgLy7uOBewAAADiXZWv1dPOG0PumYLxmEZYBAADgrN4Sgtf8cDAGAACA/4J/AOJuXlKr68ZbAAAAAElFTkSuQmCC",
    style: {
      mixBlendMode: "multiply"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 10.5,
    x2: 951,
    y2: 10.5,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    stroke: "url(#D\\xE9grad\\xE9_sans_nom_467)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBar);
export default __webpack_public_path__ + "static/media/imgBar.9d46aa9d56f47cf45b518e2391d7789e.svg";
export { ForwardRef as ReactComponent };